<template>
  <v-card class="ma-5" outlined>
    <v-toolbar flat>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <sync-button type="accounts" :exec="syncAccounts" />
      <filters
        :filters="filters"
        :options="options"
        :fetcher="fetchPensions"
        @fetching="loading = $event"
        @fetchedResults="pensions = $event"
        @fetchedTotal="totalPensions = $event"
      />
      <columns :headers="headers" @emit-headers="filteredHeaders = $event" />
    </v-toolbar>
    <v-data-table
      class="ma-5"
      :headers="filteredHeaders"
      :items="pensions"
      :loading="loading"
      loading-text="Bezig met laden..."
      :server-items-length="totalPensions"
      :options.sync="options"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
    >
      <template #no-data> {{ $t('pensiontable.nodata1') }} {{ title }} {{ $t('pensiontable.nodata2') }} </template>
      <template #item="props">
        <tr>
          <td v-if="showColumn('name')">
            {{ props.item.name }}
          </td>
          <td v-if="showColumn('en')">
            {{ props.item.translations.en }}
          </td>
          <td v-if="showColumn('fr')">
            {{ props.item.translations.fr }}
          </td>
          <td v-if="showColumn('account')">
            {{ accountName(props.item.account) }}
          </td>
          <td v-if="showColumn('pricePerDay')">
            {{ props.item.pricePerDay ? '€ ' + props.item.pricePerDay.toFixed('2') : '-' }}
          </td>
          <td v-if="showColumn('tax')">
            {{ props.item.tax }}
          </td>
          <td v-if="showColumn('action')" class="text-right d-print-none">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dark color="primary" class="mr-2" @click="() => openPensionPage(props.item._id)" v-on="on"> mdi-pencil </v-icon>
              </template>
              <span>{{ $t('pensiontable.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dark color="primary" @click="() => openDeleteDialog(props.item)" v-on="on"> mdi-delete </v-icon>
              </template>
              <span>{{ $t('pensiontable.delete') }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <delete-dialog
      :delete-dialog="deleteDialog"
      item="Protocol"
      :delete-queue="deleteQueue"
      @delete="deleteItem"
      @close="closeDeleteDialog"
    />
  </v-card>
</template>

<script>
import { accountName, compareRouteAndPush } from '@/Helpers';
import { pensionAPI, teamleaderAPI } from '@/services';
import DeleteDialog from '@/components/common/DeleteDialog';
import SyncButton from '@/components/common/SyncButton';
import Filters from '@/components/filters/Filters';
import Columns from '@/components/filters/Columns';

export default {
  components: { Filters, Columns, DeleteDialog, SyncButton },
  props: {
    title: { type: String, default: '' },
    headers: { type: Array, required: true },
    filters: { type: Object, default: () => ({}) },
  },
  data: (data) => ({
    filteredHeaders: [],
    pensions: [],
    totalPensions: 0,
    loading: false,
    options: {
      page: Number(data.$route.query.page) || 1,
      itemsPerPage: Number(data.$route.query.limit) || 10,
    },
    deleteDialog: false,
    deleteQueue: {},
    sortBy: 'name',
    sortDesc: false,
  }),
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler() {
        this.compareRouteAndPush(
          {
            ...this.$route.query,
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy,
            sortDesc: this.options.sortDesc,
          },
          this.$route,
          this.$router
        );
      },
    },
  },
  methods: {
    accountName,
    compareRouteAndPush,
    showColumn(col) {
      return this.headers.find((header) => header.value === col).selected;
    },
    openPensionPage(id) {
      this.$router.push(`/settings/pension/${id}`);
    },
    openDeleteDialog(item) {
      this.deleteQueue = item;
      this.deleteDialog = true;
    },
    closeDeleteDialog(state) {
      this.deleteQueue = {};
      this.deleteDialog = state;
    },
    async syncAccounts() {
      await teamleaderAPI.syncAccounts();
      await this.getAllPensionTypes();
    },
    async deleteItem(item) {
      try {
        this.loading = true;
        await this.$store.dispatch('errorMessage/resetError');
        await pensionAPI.delete(item._id);
        this.deleteDialog = false;
        this.deleteQueue = {};
        await this.getAllPensionTypes();
      } catch (err) {
        await this.$store.dispatch('errorMessage/set', { message: err.message, code: err.statusCode });
      } finally {
        this.loading = false;
      }
    },
    fetchPensions(URLparams) {
      return pensionAPI.getAll(URLparams);
    },
    async getAllPensionTypes() {
      try {
        this.loading = true;
        const {
          data: { results, total },
        } = await pensionAPI.getAll(this.$route.query);
        this.pensions = results;
        this.totalPensions = total;
      } catch (err) {
        await this.$store.dispatch('errorMessage/setError', { message: err.message, code: err.statusCode });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
